import { TourDataContext, TourSceneContext } from "@/context/TourContexts";
import { useContextSelector } from "use-context-selector";
import { useAppContext } from "./useAppContext";
import { useAuthContext } from "./useAuthContext";

export const useApp = () => {
  const context = useAppContext();
  if (!context) throw new Error("useApp debe usarse dentro de AppProvider");
  return context;
};

export const useAuth = () => {
  const context = useAuthContext();
  if (!context) throw new Error("useAuth debe usarse dentro de AuthProvider");
  return context;
};

export const useCurrentSceneId = () =>
  useContextSelector(
    TourSceneContext,
    (ctx) => ctx?.currentScene?.scene_id ?? null,
  );

export const useCurrentSceneRoomId = () =>
  useContextSelector(
    TourSceneContext,
    (ctx) => ctx?.currentScene?.room_id ?? null,
  );

export const useTourRefresh = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.refresh);

export const useUpdateTourLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.updateTourLocal);

export const useUpdateSceneLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.updateSceneLocal);

export const useUpdateRoomLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.updateRoomLocal);

export const useUpdateFloorLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.updateFloorLocal);

export const useAddFloorLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.addFloorLocal);

export const useAddSceneLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.addSceneLocal);

export const useAddRoomLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.addRoomLocal);

export const useRemoveSceneLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.removeSceneLocal);

export const useRemoveRoomLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.removeRoomLocal);

export const useRemoveFloorLocal = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.removeFloorLocal);

export const useTourPendingScenes = () =>
  useContextSelector(TourDataContext, (ctx) => ctx?.pendingScenes ?? []);

export const useAddPendingScene = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.addPendingScene);

export const useRemovePendingScene = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.removePendingScene);

export const useUpdatePendingSceneProgress = () =>
  useContextSelector(TourDataContext, (ctx) => ctx!.updatePendingSceneProgress);

export const useTourAllScenes = () =>
  useContextSelector(TourDataContext, (ctx) => ctx?.allScenes ?? []);

export const useTourAllFloors = () =>
  useContextSelector(TourDataContext, (ctx) => ctx?.allFloors ?? []);

export const useTourAllRooms = () =>
  useContextSelector(TourDataContext, (ctx) => ctx?.allRooms ?? []);

export const useTour = () =>
  useContextSelector(TourDataContext, (ctx) => ctx?.tour ?? null);

export const useTourData = () => {
  const ctx = useContextSelector(TourDataContext, (ctx) => ctx);
  if (!ctx) throw new Error("useTourData debe usarse dentro de TourProvider");
  return ctx;
};

export const useCurrentScene = () =>
  useContextSelector(TourSceneContext, (ctx) => ctx?.currentScene ?? null);

export const useCurrentSceneFloorId = () =>
  useContextSelector(
    TourSceneContext,
    (ctx) => ctx?.currentScene?.floor_id ?? null,
  );

export const useSelectScene = () =>
  useContextSelector(TourSceneContext, (ctx) => ctx?.selectScene ?? (() => {}));

export const useClearScene = () =>
  useContextSelector(TourSceneContext, (ctx) => ctx?.clearScene ?? (() => {}));

export const useTourScene = () => {
  const ctx = useContextSelector(TourSceneContext, (ctx) => ctx);
  if (!ctx) throw new Error("useTourScene debe usarse dentro de TourProvider");
  return ctx;
};
